<!--
 * @Author: Czy
 * @Date: 2024-08-20 15:29:14
 * @FilePath: /museum-wechat/src/components/dict-text/dict-text.vue
 *  
-->
<template>
  <template v-for="item in dictOption" :key="item.type + item.value">
    <view v-if="item.value == newValue">

      <slot v-bind="{ dict: item }"></slot>

      <text v-if="!$slots.default" :style="{ color: switchColor(listClass) }">
        {{ item.label }}
      </text>
    </view>
  </template>
</template>
<script lang="ts" setup>
import { computed, withDefaults } from 'vue'
import useDict from '@/utils/dict'

const props = withDefaults(
  defineProps<{
    type: string | string[]
    value?: string | number
    listClass?: string
  }>(),
  {
    value: '',
    listClass: 'primary',
  },
)

const type = Array.isArray(props.type) ? props.type : [props.type]
const dict = useDict(...type)
const dictOption = computed(() => {
  return type.flatMap((t) => {
    return dict.value[t] || []
  })
})
const switchColor = (listClass: string) => {
  switch (listClass) {
    case 'danger':
      return '#fa4350'
    case 'default':
      return '#4D80F0'
    case 'success':
      return '#34d19d'
    case 'info':
      return '#aaaaaa'
    default:
      return '#2F2F2F'
  }
}
const newValue = computed(() => props.value)
</script>
